import { CanActivateChildFn } from '@angular/router'

export const componentTestGuard: CanActivateChildFn = (route, state) => {
    const hostname = window.location.hostname
    const isNonProductionHost = [
        'localhost',
        '127.0.0.1',
        '::1',
        '[::1]',
        'dev2-mit.evida.dk',
        'uat-mit.evida.dk',
    ].includes(hostname)

    if (!isNonProductionHost) {
        console.warn('Access denied: This page is only available on non-production hosts')
    }

    return isNonProductionHost
}
